/** Query keys for the client portal (one factory; mutations invalidate by prefix). */

const scope = (projectId?: string) => projectId ?? 'all';

export const portalKeys = {
  all: ['portal'] as const,
  me: () => [...portalKeys.all, 'me'] as const,
  project: (id: string) => [...portalKeys.all, 'project', id] as const,
  invoices: (projectId?: string) => [...portalKeys.all, 'invoices', scope(projectId)] as const,
  receipts: () => [...portalKeys.all, 'receipts'] as const,
  purchases: (projectId?: string) => [...portalKeys.all, 'purchases', scope(projectId)] as const,
  approvalsAll: () => [...portalKeys.all, 'approvals'] as const,
  approvals: (projectId?: string) => [...portalKeys.approvalsAll(), 'list', scope(projectId)] as const,
  approval: (id: string) => [...portalKeys.approvalsAll(), 'detail', id] as const,
  documents: (projectId?: string) => [...portalKeys.all, 'documents', scope(projectId)] as const,
  moodboards: (projectId?: string) => [...portalKeys.all, 'moodboards', scope(projectId)] as const,
  file: (fileId: string, width?: number) => [...portalKeys.all, 'file', fileId, width ?? 'full'] as const,
};
